import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import SingleRangeBuckets from "./SingleRangeBuckets";
import SingleRangeBox from "./SingleRangeBox";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function TwoChartTemplate({ title, type, gloablfilter }) {
  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div
        className={
          loggedInUser.flagForHideShow !== "ERC"
            ? "chartbox drive_graph"
            : "chartbox drive_graph p-0"
        }
      >
        {/* <div className="row"> */}
        <div className={loggedInUser.flagForHideShow !== "ERC" ? "row" : ""}>
          <div
            className={
              loggedInUser.flagForHideShow !== "ERC" ? "col-md-12" : ""
            }
          >
            <div
              className={
                loggedInUser.flagForHideShow !== "ERC"
                  ? "titlebg titlebd_drive p-2 pb-0"
                  : "titlebg titlebd_drive box_title pt-2 pb-2"
              }
            >
              {title}
            </div>
          </div>
          {type === "RANGE" ? (
            <>
              {loggedInUser.flagForHideShow !== "ERC" && (
                <SingleRangeBox
                  title={title}
                  gloablfilter={gloablfilter}
                  apiend="rangeboxchart"
                  yaxis_title="Range"
                  idStr="Range"
                />
              )}
              <SingleRangeBuckets
                title={title}
                gloablfilter={gloablfilter}
                apiend={
                  loggedInUser.flagForHideShow !== "ERC"
                    ? "rangebarchart"
                    : "rangebarchart_erc"
                }
                yaxis_title="Vehicle Count"
              />
            </>
          ) : (
            <>
              {loggedInUser.flagForHideShow !== "ERC" && (
                <SingleRangeBox
                  title={title}
                  gloablfilter={gloablfilter}
                  apiend="energyboxchart"
                  yaxis_title="Wh/km"
                  idStr="Whkm"
                />
              )}
              <SingleRangeBuckets
                title={title}
                gloablfilter={gloablfilter}
                apiend={
                  loggedInUser.flagForHideShow !== "ERC"
                    ? "energybarchart"
                    : "energybarchart_erc"
                }
                yaxis_title="Vehicle Count"
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default TwoChartTemplate;
